const data = {
  primaryColor: "#8BC34A",
  lightColor: false,
  title: "Sound Meter",
  category: "Tools",
  icon: "/images/app-icons/sound-meter.png",
  slogan: "Easy-to-use application for measuring sound levels around you",
  shortDescription:
    "Easy-to-use application for measuring sound levels around you. It can display current noise levels around you. minimum/average/maximum decibel values and warnings for high levels of noise. It also features graph with measured values for the last minute.",
  fullDescription:
    "Sound meter is simple and easy-to-use sound level meter (or SPL) for your Android device. In it's user-friendly interface, it displays current noise levels around you. minimum/average/maximum decibel values, and warnings for high levels of noise. It also features graph with measured values for the last minute. Sound meter is an essential tools for those, who are curious about the sound levels around them. <br /><br /><b>Warning</b><br />" +
    "This application can be only use as an auxiliary tools. If you want more accurate measurements, I recommend an actual sound level meter for that.<br />" +
    "Microphones in most android devices are aligned to human voice. The maximum values are limited by the device. Very loud sounds may not be recognized.  ",
  usesCases: ["Measuring sound levels around you"],
  properties: [
    "Display the current noise level",
    "Display min/avg/max decibel values",
    "Display warning for high level of noise",
    "Display measured values for the last minute in graph",
  ],
  services: [],
  pricing: "Free",
  android: {
    permissions: [
      {
        name: "Microphone",
        reason: "measuring sound level around device",
      },
    ],
    requirements: "Device microphone.",
    requiredAndroidVersion: "7.0 and up",
    versioning: {
      releasedOn: new Date(2021, 6, 30),
      currentVersion: "1.1",
      updatedOn: new Date(2023, 1, 27),
    },
    availableOn: {
      googlePlayURL:
        "https://play.google.com/store/apps/details?id=dev.davidsimak.soundmeter",
    },
    languages: {
      supported: "English",
      inProgress: null,
    },
    deviceCompatibility: {
      phone: true,
      tablet: true,
    },
    techInformation: {
      language: "Java 11",
      logging: "ACRA",
      database: null,
      integrations: [],
      libraries: [],
      plugins: [],
    },
    images: [
      {
        title: "Main screen",
        url: "/images/project-screenshots/sound-meter/sound-meter-android-1.png",
        description:
          "Main screen with graphs and information about sound level",
      },
      {
        title: "Main screen",
        url: "/images/project-screenshots/sound-meter/sound-meter-android-2.png",
        description:
          "Main screen with graphs and information about sound level",
      },
      {
        title: "Main screen",
        url: "/images/project-screenshots/sound-meter/sound-meter-android-3.png",
        description:
          "Main screen with graphs and information about sound level",
      },
      {
        title: "Main screen",
        url: "/images/project-screenshots/sound-meter/sound-meter-android-4.png",
        description:
          "Main screen with graphs and information about sound level",
      },
      {
        title: "Main screen",
        url: "/images/project-screenshots/sound-meter/sound-meter-android-5.png",
        description:
          "Main screen with graphs and information about sound level",
      },
      {
        title: "Main screen",
        url: "/images/project-screenshots/sound-meter/sound-meter-android-6.png",
        description:
          "Main screen with graphs and information about sound level",
      },
      {
        title: "Main screen",
        url: "/images/project-screenshots/sound-meter/sound-meter-android-7.png",
        description:
          "Main screen with graphs and information about sound level",
      },
    ],
  },
  frontend: null,
  backend: null,
};

class SoundMeterProjectData {
  get() {
    return data;
  }

  getAsItem() {
    return {
      tag: "sound-meter",
      title: data.title,
      category: data.category,
      icon: data.icon,
      shortDescription: data.shortDescription,
      platform: {
        android: data.android !== null,
        frontend: data.frontend !== null,
        backend: data.backend !== null,
      },
    };
  }

  getIfCategoryIsMatched(categoryName) {
    if (categoryName === data.category) {
      return this.getAsItem();
    }

    return undefined;
  }
}

export default new SoundMeterProjectData();
